import Text from "../Text/Text";

export const FormField: React.FC<{
  label: string;
  error?: string;
  touched?: boolean;
  children: React.ReactNode;
}> = ({ label, error, touched, children }) => {
  const hasError = error && touched;
  
  return (
    <div className="form-group">
      <Text className="text-body">{label}</Text>
      {children}
      {hasError && (
        <Text className="text-caption text-error">
          {error}
        </Text>
      )}
    </div>
  );
};

